<template>
	<v-container grid-list-xl>
		<v-layout row wrap>			
			<v-flex lg12>               
				<v-data-table :headers="headers" v-if="productSalesSelectProducts != null && this.headers.length == 8" :search="search" :items="productSalesSelectProducts" class="elevation-1" style="font-size: 10px;" :rows-per-page-items="[20,40,50,100]">
					<template slot="items" slot-scope="props">
						<td class="text-xs-right" v-html="fncFilterName(props.item.name)">{{ fncFilterName(props.item.name) }}</td>
						<td class="text-xs-right">{{ props.item.uom }}</td>
						<td class="text-xs-right">{{ fncAveragePrice(props.item.gross,props.item.quantity) }}</td>
						<td class="text-xs-right">{{ props.item.quantity }}</td>
						<td class="text-xs-right">{{ fncFilterPrice(props.item.gross) }}</td>
						<td class="text-xs-right">{{ fncFilterPrice(props.item.discount) }}</td>
						<td class="text-xs-right">{{ fncFilterPrice(props.item.nett) }}</td>
						<td class="text-xs-right"><a @click.prevent="fncViewDates(props.item.products)"><i class="material-icons">shopping_cart</i></a></td>
					</template>
				</v-data-table>
				<p v-if="dateList != null && this.headers.length == 11"><strong>{{ productFilter }}</strong></p>
				<v-data-table :headers="headers" v-if="dateList != null && this.headers.length == 11" :search="search" :items="dateList" class="elevation-1" style="font-size: 10px;" :rows-per-page-items="[20,40,50,100]">
					<template slot="items" slot-scope="props">
						<td class="text-xs-right">{{ props.item.date }}</td>
						<td class="text-xs-right">{{ props.item.quote_no }}</td>
						<td class="text-xs-right">{{ props.item.status }}</td>
						<td class="text-xs-right">{{ props.item.tender_status }}</td>
						<td class="text-xs-right">{{ props.item.originator_name }}</td>
						<td class="text-xs-right">{{ props.item.customer_name }}</td>
						<td class="text-xs-right">{{ props.item.quantity }}</td>
						<td class="text-xs-right">{{ fncFilterPrice(props.item.gross_total) }}</td>
						<td class="text-xs-right">{{ fncFilterPrice(props.item.discount_total) }}</td>
						<td class="text-xs-right">{{ fncFilterPrice(props.item.nett_total) }}</td>
						<td class="text-xs-right"><a @click.prevent="fncViewQuote(props.item)"><i class="material-icons">list_alt</i></a></td>
					</template>
				</v-data-table>

			</v-flex>
			<div class="pl-4 pr-1 pb-4 buttonHolder">
				<div style="float: right">
					<v-btn class="text-xs-right" v-if="productSalesSelectProducts != null && this.headers.length == 11" @click.stop="fncResetProducts()">Reset Products</v-btn>
					<v-btn color="success" class="text-xs-right cancelButton" @click.stop="fncHideModal">Close</v-btn>
				</div>	
			</div>							
		</v-layout>
	</v-container>
</template>

<script>
	import { mapGetters } from 'vuex';
	export default {
	  name: 'Settings',
	  data () {
			return {
			    productList: [],
				dateList: [],
                search: '',
                headers: [
                    { text: 'Product', value: '' },
                    { text: 'UOM', value: '' },
                    { text: 'Avg Unit Price', value: '' },
                    { text: 'Quantity', value: '' },
                    { text: 'Gross Total', value: '' },
                    { text: 'Discount Total', value: '' },
                    { text: 'Nett Total', value: '' },
                    { text: 'View', value: '' }
                ],
				productFilter: ''
			};
		},		
		methods: {
			fncHideModal () {
				this.$store.commit('hideModal');
			},
            fncFilterPrice( filterVar ) {
                var currencyValue = parseFloat(filterVar).toFixed(2);
                currencyValue = currencyValue.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
                return 'R' + currencyValue;
            },
			fncFilterName(name) {
				var dataUrl = name.replace(/%20/g, " ");
				dataUrl = dataUrl.replace(/%27/g, "'");
				dataUrl = dataUrl.replace(/%3A/g, ":");
				dataUrl = dataUrl.replace(/%3B/g, ";");
				dataUrl = dataUrl.replace(/%3C/g, "<");
				dataUrl = dataUrl.replace(/%3D/g, "=");
				dataUrl = dataUrl.replace(/%3E/g, ">");
				dataUrl = dataUrl.replace(/%2C/g, ",");
				dataUrl = dataUrl.replace(/%28/g, "(");
				dataUrl = dataUrl.replace(/%29/g, ")");
				
				return dataUrl;
			},
            fncViewDates( products ){
                this.headers = [
                    { text: 'Date', value: '' },
                    { text: 'Quote No.', value: '' },
                    { text: 'Quote Status', value: '' },
                    { text: 'Quote Tender Status', value: '' },
                    { text: 'Originator', value: '' },
                    { text: 'Customer', value: '' },
                    { text: 'Quantity', value: '' },
                    { text: 'Gross Total', value: '' },
                    { text: 'Discount Total', value: '' },
                    { text: 'Nett Total', value: '' },
                    { text: 'View Quote', value: '' },
                ];
               this.dateList = [];
                for( var k in products ) {
                    this.productFilter = products[k].product_name;
                    this.dateList.push(products[k]);
				}
			},
            fncAveragePrice( total, quantity){
			    var avgPrice = parseFloat( parseInt(total) / parseFloat(quantity) ).toFixed(2);
			    return 'R' + avgPrice.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
			},
            fncResetProducts() {
                this.headers = [
                    { text: 'Product', value: '' },
                    { text: 'UOM', value: '' },
                    { text: 'Avg Unit Price', value: '' },
                    { text: 'Quantity', value: '' },
                    { text: 'Gross Total', value: '' },
                    { text: 'Discount Total', value: '' },
                    { text: 'Nett Total', value: '' },
                    { text: 'View', value: '' }
                ]
			},
            fncViewQuote(quoteId) {
                this.$store.commit('hideModal');
				var modalDetails = { title: 'Quote Details - #' + quoteId.id, component: 'modal-quote-details', mstate: true, params: {} };
                this.$store.commit({
                    type: 'setModal',
                    details: modalDetails
                });
                this.$store.dispatch({
					type: 'fncSetQuoteDetails',
					quoteId: quoteId.id,
					quote: quote
				});
			}
		},
		computed: {
			...mapGetters([			
				'objAuthorize',				
				'globalModalParams',
                'productSaleRange',       
				'productSalesSelectProducts'
			])
		},
        mounted() {
          console.log('mounted');
	      this.$store.dispatch({
			  type: 'fncSalesProducts',
			  range: this.globalModalParams.rangeName
		  })
		},
		watch:{
            productSaleRange() {
                this.$store.dispatch({
                    type: 'fncSalesProducts',
                    range: this.productSaleRange
                })
			}
		}
	}
</script>

<style scoped>
	/*@import '../../assets/css/shared.css'*/
</style>